export default __webpack_public_path__ + "static/media/ProfileImage2.fd37d90b.jpg";